import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Modal, Grid, Checkbox, Form } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';
import { EntityEntityTypeId } from 'services/entities/types';

// Global Components
// @ts-ignore
import EntityTypeName from 'components/EntityTypeName';

// Global Actions
import { removeEntities } from 'services/entities/actions';
// @ts-ignore
import { resetSelectedTableCells } from 'services/selectedTableCells/actions';
import { updateQueryString } from 'services/router/actions';

// Global Selectors
// @ts-ignore
import { selectActiveTableCellRowIds } from 'services/selectedTableCells/selectors';
// @ts-ignore
import { makeSelectChildEntityTypePluralNames } from 'services/entityTypes/selectors';

// Local Constants
import { ENTITIES_ARCHIVE_MODAL_PARAM } from '../../constants';

export interface OwnProps {
    entityTypeId: EntityEntityTypeId;
}

interface ConnectedProps {
    entityUuids?: string[];
    childEntityTypePluralNames?: string;
}

interface DispatchProps {
    removeEntities: typeof removeEntities;
    resetSelectedTableCells: typeof resetSelectedTableCells;
    updateQueryString: typeof updateQueryString;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

interface State {
    checked1: boolean;
    checked2: boolean;
}

export class EntitiesArchiveFormComponent extends React.PureComponent<
    Props,
    State
> {
    state = {
        checked1: false,
        checked2: false,
    };

    componentDidMount(): void {
        const { entityUuids } = this.props;
        if (!entityUuids || !entityUuids.length) {
            this.handleClose();
        }
    }

    get submitDisabled(): boolean {
        const { childEntityTypePluralNames } = this.props;
        const { checked1, checked2 } = this.state;

        if (!childEntityTypePluralNames) {
            return !checked1;
        }

        return !checked1 || !checked2;
    }

    handleClick = (): void => {
        const { entityUuids, ...props } = this.props;

        if (entityUuids && entityUuids.length) {
            props.removeEntities(entityUuids);

            props.resetSelectedTableCells();
        }

        this.handleClose();
    };

    handleClose = (): void => {
        this.props.updateQueryString({
            [ENTITIES_ARCHIVE_MODAL_PARAM]: undefined,
        });
    };

    handleChange1 = (): void => {
        this.setState((prevState) => ({ checked1: !prevState.checked1 }));
    };

    handleChange2 = (): void => {
        this.setState((prevState) => ({ checked2: !prevState.checked2 }));
    };

    render(): React.ReactElement {
        const {
            entityTypeId,
            entityUuids = [],
            childEntityTypePluralNames,
        } = this.props;
        const { checked1, checked2 } = this.state;
        return (
            <React.Fragment>
                <Modal.Header>
                    Archive{' '}
                    <EntityTypeName
                        entityTypeId={entityTypeId}
                        plural={entityUuids.length > 1}
                    />
                </Modal.Header>
                <Modal.Content>
                    <p>
                        <b>Warning: this cannot be undone.</b>
                    </p>
                    <Form>
                        <Form.Field>
                            <Checkbox
                                label="All Jobs will be archived"
                                onChange={this.handleChange1}
                                checked={checked1}
                            />
                        </Form.Field>
                        {childEntityTypePluralNames && (
                            <Form.Field>
                                <Checkbox
                                    label={`All ${childEntityTypePluralNames} will be archived`}
                                    onChange={this.handleChange2}
                                    checked={checked2}
                                />
                            </Form.Field>
                        )}
                        <Grid>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="submit"
                                    onClick={this.handleClick}
                                    negative
                                    fluid
                                    disabled={this.submitDisabled}
                                >
                                    Archive{' '}
                                    <EntityTypeName
                                        entityTypeId={entityTypeId}
                                        plural={entityUuids.length > 1}
                                    />
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Form>
                </Modal.Content>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityUuids: selectActiveTableCellRowIds,
    childEntityTypePluralNames: makeSelectChildEntityTypePluralNames(),
});

export default connect(mapStateToProps, {
    removeEntities,
    resetSelectedTableCells,
    updateQueryString,
})(EntitiesArchiveFormComponent);
